import React from "react";
import Layout from "./layout/Layout";

export default function App() {
  return (
    <div>
      <Layout />
    </div>
  );
}
